import * as yup from 'yup';
import { validateShipmentTrackingNumber } from '../../helpers/formHelpers/formHelpers';
import ITHomeDelivery from '../../interfaces/homeDelivery/homeDelivery';

export const homeDeliveryInitialValues: ITHomeDelivery = {
	trackingnumber: '',
	customerEmail: '',
	phone: '',
	name: '',
	address: '',
	zip: '',
	captchaValid: false,
};

export const homeDeliverySchema = yup.object().shape({
	trackingnumber: yup
		.string()
		.required('trackingnumberRequired')
		.test('validateTrackingNumbers', 'trackingnumberWrong', value => {
			if (!value) return false;
			const numbers = value
				.split(/[\s,]+/) // split on space, comma, or newline
				.filter(n => n); // remove empty strings
			return numbers.every(validateShipmentTrackingNumber);
		}),
	customerEmail: yup.string().email('emailNotValid').required('emailRequired'),
	phone: yup
		.string()
		.required('phoneRequired')
		.matches(/^[6-8][0-9]*$/, 'phoneNotValid')
		.min(7, 'phoneMin')
		.max(15, 'phoneMax'),
	name: yup.string().required('nameRequired'),
	address: yup.string().required('addressRequired'),
	zip: yup.string().required('zipRequired'),
	// captchaValid: yup.boolean().test('is-valid-captcha', 'captcha-valid', value => value),
});
